import { useState } from 'react';
import { toast } from 'react-toastify';
import ToastMessages from '../../components/ToastMessages/toastMessages';
import { api } from '../../services/api';

interface DeliveryEvent {
  deliveryId?: string;
  problemDescription?: string;
  status?: string;
  eventType: string;
  timestamp: Date;
  deletedAt?: Date;
}

interface ErrorData {
  message: string[];
}

export default function useGetDeliveryEvents() {
  const [loading, setLoading] = useState(false);

  async function execute(params: {
    deliveryId?: string;
    cartId?: string;
    freightId?: string;
  }) {
    try {
      setLoading(true);
      if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line no-console
        console.log('[delivery-events] request params:', params);
      }

      const response = await api.get<DeliveryEvent[]>(
        'v1/backoffice/delivery-events',
        {
          params: params,
        },
      );

      if (response.status === 200) {
        if (process.env.NODE_ENV !== 'production') {
          console.log(
            '[delivery-events] response count:',
            response.data?.length,
          );
          console.log('[delivery-events] sample:', response.data?.[0]);
        }
        return response.data;
      }
    } catch (error: any) {
      const errorData = error.response?.data as ErrorData;
      if (process.env.NODE_ENV !== 'production') {
        console.log('[delivery-events] error:', error);
      }

      if (errorData && errorData.message && Array.isArray(errorData.message)) {
        errorData.message.forEach(err => toast.error(err));
      } else {
        toast.error(ToastMessages.general.error.genericError);
      }
    } finally {
      setLoading(false);
    }
  }

  return { execute, loading };
}
